<div class="container">
  <div
    class="close-button"
    (click)="closeFirstVisit()">
    <mat-icon>close</mat-icon>
  </div>
  <div class="content">
    <div
      class="header"
      cdkDrag
      cdkDragRootElement=".container"
      cdkDragHandle
      [cdkDragFreeDragPosition]="offset">
      <h3
        #testITEM
        class="fv-header-text">
        {{ 'guided-tour.top-headline' | translate }}
      </h3>
      <coin-simple-lang-switch></coin-simple-lang-switch>
    </div>
    @if (specialImageData) {
      <div
        class="special-image"
        [ngStyle]="{ 'background-image': 'url(' + specialImageData + ')' }"></div>
    }
    <mat-tab-group
      class="invisible-tabs"
      [selectedIndex]="selectedTab"
      (selectedIndexChange)="tabChange($event)">
      <mat-tab>
        <ng-template matTabContent>
          <app-intro
            class="max-height-area"
            [maxHeight]="tourMaxHeight"></app-intro>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template matTabContent>
          <app-fv-left
            [image]="imageLink"
            [text]="text"
            [maxHeight]="tourMaxHeight"
            [needsColumn]="needsColumn"></app-fv-left>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template matTabContent>
          <app-fv-right
            [image]="imageLink"
            [text]="text"
            [maxHeight]="tourMaxHeight"
            [needsColumn]="needsColumn"></app-fv-right>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template matTabContent>
          <app-fv-left
            [image]="imageLink"
            [text]="text"
            [maxHeight]="tourMaxHeight"
            [needsColumn]="needsColumn"></app-fv-left>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template matTabContent>
          <app-fv-right
            [image]="imageLink"
            [text]="text"
            [maxHeight]="tourMaxHeight"
            [needsColumn]="needsColumn"></app-fv-right>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template matTabContent>
          <app-fv-left
            [image]="imageLink"
            [text]="text"
            [maxHeight]="tourMaxHeight"
            [needsColumn]="needsColumn"></app-fv-left>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template matTabContent>
          <app-fv-right
            [image]="imageLink"
            [text]="text"
            [maxHeight]="tourMaxHeight"
            [needsColumn]="needsColumn"></app-fv-right>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <div class="fv-buttons">
      @if (selectedTab > 0) {
        <coin-v2-button
          type="secondary"
          icon="chevron_left"
          iconPos="left"
          [text]="'general.btnBack' | translate"
          (click)="back()"></coin-v2-button>
      }
      @if (selectedTab < 6) {
        <coin-v2-button
          text="{{ selectedTab > 0 ? ('general.btnNext' | translate) : ('guided-tour.start-tour' | translate) }}"
          class="button-right"
          type="primary"
          icon="chevron_right"
          iconPos="right"
          (click)="next()"></coin-v2-button>
      }
      @if (selectedTab === 6) {
        <coin-v2-button
          class="button-right"
          type="primary"
          icon="chevron_right"
          iconPos="right"
          [text]="'guided-tour.tour-completed' | translate"
          (click)="completeTour()"></coin-v2-button>
      }
    </div>
    <div class="fv-fake-item">
      @if (showFakeItem && fakeItem) {
        <app-topic-item
          class="topic-item-container fake-child"
          animate.enter="expand"
          animate.shrink="shrink"
          [item]="$any(fakeItem)"></app-topic-item>
      }
    </div>
  </div>
</div>
@if (nso) {
  <div
    class="new-special-overlay"
    [ngStyle]="{
      'border-top-width': nso.bt,
      'border-bottom-width': nso.bb,
      'border-left-width': nso.bl,
      'border-right-width': nso.br
    }"></div>
}
